<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form
              :inline="true"
              ref="form"
              :model="searchForm"
              class="demo-form-inline"
            >
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input
                    v-model="searchForm.name"
                    placeholder="名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="searchForm.phone"
                    placeholder="手机"
                  ></el-input>
                </el-form-item>
                <el-form-item label="证件类型：">
                  <el-select
                    v-model="searchForm.documentTypeId"
                    placeholder="选择证件类型"
                  >
                    <el-option label="全部类型" value="0"> </el-option>
                    <el-option
                      v-for="(type, index) in DocumentType"
                      :label="type.name"
                      :key="index"
                      :value="type.documentTypeId"
                      >{{ type.name }}
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="等级：">
                  <el-select v-model="searchForm.level" placeholder="选择等级">
                    <el-option label="全部" value="-1">
                      <div @click="getChangeType(-1)">全部</div>
                    </el-option>
                    <el-option label="1级" value="0">
                      <div @click="getChangeType(0)">1级</div>
                    </el-option>
                    <el-option label="2级" value="1">
                      <div @click="getChangeType(1)">2级</div>
                    </el-option>
                    <el-option label="3级" value="2">
                      <div @click="getChangeType(2)">3级</div>
                    </el-option>
                    <el-option label="4级" value="3">
                      <div @click="getChangeType(3)">4级</div>
                    </el-option>
                    <el-option label="5级" value="4">
                      <div @click="getChangeType(4)">5级</div>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="searchSubmit"
                  >搜索</el-button
                >
              </div>
              <div class="uers-right">
                <span class="btn-r">
                  <el-button
                    type="primary"
                    plain
                    icon="el-icon-plus"
                    @click="addSubmit"
                    >新增</el-button
                  >
                </span>
                <el-popover
                  placement="bottom"
                  title="批量导入"
                  width="220"
                  trigger="click"
                >
                  <div>
                    <el-upload
                      class="upload-demo"
                      :action="action"
                      :auto-upload="false"
                      :on-change="uploadChange"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    >
                      <el-button size="small" type="primary"
                        >选择导入模板</el-button
                      >
                    </el-upload>
                    <el-button
                      type="success"
                      @click="download"
                      plain
                      icon="el-icon-download"
                      class="down-template"
                      >下载模板</el-button
                    >
                  </div>
                  <p class="import-text">只能选择 .xls .xlsx 文件</p>
                  <div>
                    <el-button type="success" @click="importData"
                      >上传模板</el-button
                    >
                  </div>
                  <el-button
                    type="primary"
                    plain
                    icon="el-icon-upload2"
                    slot="reference"
                    >开始导入</el-button
                  > </el-popover
                >&nbsp;&nbsp;&nbsp;
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
              :data="dataList"
              height="100%"
              border
              class="tabbox"
              ref="multipleTable"
              :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="55"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="phone"
                label="分发地址"
                align="center"
                width="200"
              >
                <template slot-scope="scope">
                  <span>{{ url + "/d/" + scope.row.distributeId }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="姓名" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="level" label="等级" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.level + 1 }}级</span>
                </template>
              </el-table-column>
              <el-table-column prop="phone" label="手机" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.phone }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="typeName" label="类型" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.typeName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="total" label="总量" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.total }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="useNumber" label="已使用量" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.useNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="createDate"
                label="创建日期"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="handleEdit(scope.$index, scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    class="red"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
              class="pag"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
          :delVisible="delVisible"
          @deleteData="deleteData"
          @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditDisManage
          :editShow="editShow"
          :editData="editData"
          @backFunStu="getFunStu"
        ></EditDisManage>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditDisManage from "../../../components/ticketing/certificate/EditDisManage";
import DocumentType from "../../../components/ticketing/certificate/docuType/DocumentType";
import DeleteDialog from "../../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      //表格高度适配
      tabheight: "",
      searchForm: {
        name: "",
        phone: "",
        level: "-1",
        documentTypeId: "0",
      },
      url: localStorage.getItem("url").replace("/api", ""),
      projectId: localStorage.getItem("project_Id"),
      DocumentType: [],
      editData: {},
      listShow: true,
      delVisible: false,
      distributeId: "",
      editShow: false,
      dataList: [],
      multipleSelection: [],
    };
  },
  mounted() {
    // this.tabheight=(this.$refs.getheight.offsetHeight-165)
  },
  created() {
    this.getData();
    this.getDocumentType();
  },
  methods: {
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      var search = {
        name: this.searchForm.name,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        level: this.searchForm.level,
        phone: this.searchForm.phone,
        projectId: this.projectId,
        documentTypeId: this.searchForm.documentTypeId,
      };
      this.$axios.post("/Distribute/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    // 获取数据
    getData() {
      this.searchSubmit();
    },
    addSubmit() {
      this.distributeId ="";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    handleDelete(index, row) {
      this.distributeId = row.distributeId;
      this.delVisible = true;
    },
    deleteData() {
      this.$axios.delete(`/Distribute/${this.distributeId}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    getDocumentType() {
      this.$axios.get("/DocumentType/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.DocumentType = [...res.data.data];
        }
      });
    },
    getChangeType(type) {
      this.searchForm.level = type;
    },
    handleCloseVisible() {
      this.ticketCom_Id = "";
      this.delVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
    download() {
      var url = localStorage.getItem("url");
      if (url.lastIndexOf("/api") == url.indexOf("/api")) {
        window.open(url.replace("/api", "/") + "/data/分发模板.xlsx");
      } else {
        window.open(
          url.substring(0, url.lastIndexOf("/api")) +
            "/data/分发模板.xlsx"
        );
      }
    },
    uploadChange(file, fileList) {
      let inputDOM = this.$refs.inputer; // 通过DOM取文件数据

      this.file = event.currentTarget.files[0];
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;

      var reader = new FileReader(); //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64",
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
            });
          } // outdata就是你想要的东西 excel导入的数据
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // excel 数据再处理
          let ar = [];
          outdata.map((v) => {
            let obj = {};
            obj.name = v.姓名;
            obj.phone = v.手机号;
            obj.total = v.数量;
            ar.push(obj);
          });
          localStorage.setItem("attr", JSON.stringify(ar));
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    importData() {
      if (this.searchForm.documentTypeId != "0") {
        this.attr = JSON.parse(localStorage.getItem("attr"));
        if (this.attr && this.attr.length > 0) {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.$axios
            .post(
              "/Distribute/" +
                this.projectId +
                "/" +
                this.searchForm.documentTypeId,
              this.attr
            )
            .then((res) => {
              if (res.data.hasError == false) {
                loading.close();
                this.searchSubmit();
                localStorage.setItem("attr", null);
                this.$message.success(res.data.message);
              } else {
                this.$message.error(res.data.message);
                loading.close();
              }
            })
            .catch(function () {
              loading.close();
            });
        } else {
          this.$message.error("没有可上传的数据");
        }
      } else {
        this.$message.error("请选择证件类型");
      }
    },
  },
  components: {
    EditDisManage,
    DocumentType,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}
.table-wrap {
  height: 100%;
  margin-left: 10px;
}
.el-main {
  border-radius: 5px;
  position: relative;
}
.uers-left {
  float: left;
}
.uers-right {
  float: right;
}
.el-dialog {
  height: auto;
}
.uers-import {
  margin-right: 30px;
  float: right;
  width: 240px;
}
.upload-excel {
  float: left;
}
.import-bnt {
  float: right;
}
.el-upload {
  height: 32px !important;
  line-height: 32px !important;
  width: 120px !important;
}
.el-upload--text {
  border: 0;
}
.file-up {
  width: 100px;
  position: absolute;
  height: 32px;
  opacity: 0;
}
.import-text {
  margin: 15px 0;
}
.el-upload--text {
  width: 110px;
  height: 32px;
  line-height: 32px;
  border: 0;
}
.down-template {
  position: absolute;
  top: 40px;
  right: 10px;
}
</style>